import React from 'react';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';
import { GoToButton } from './go.to.button';

import './grow.your.business.less';

const GrowYourBusiness = function () {
  const { t } = useTranslation();

  return (
    <div className="m-globalContentContainer">
      <div className="a-growBusiness__title"><Trans>grow.business.title</Trans></div>
      <div className="a-growBusiness__subtitle"><Trans>grow.business.subtitle</Trans></div>
      <div className="a-growBusiness__buttonContainer">
        <GoToButton />
      </div>
      <div className="a-growBusiness__imageContainer">
        <StaticImage
          src="../../../../images/getLoan/banner.png"
          alt={t('grow.business.subtitle')}
          title={t('grow.business.title')}
        />
      </div>
    </div>
  );
};

GrowYourBusiness.propTypes = {};

export default GrowYourBusiness;
